/**
 * F17 T17.1.5 — registry custom node types dla Reactflow.
 *
 * `nodeTypes` mapuje nasz schema `ProcessNodeType` (start / decision /
 * parallel_split / parallel_join / end) na React komponenty. Przekazywany do
 * `<ReactFlow nodeTypes={nodeTypes} />` w ProcessGraph.
 *
 * UWAGA: nodeTypes MUSI być stabilną referencją (poza component scope) —
 * inaczej Reactflow re-renderuje całość przy każdym renderze parent'a.
 */

import type { NodeTypes } from '@xyflow/react';

import { DecisionNode } from './DecisionNode';
import { EndNode } from './EndNode';
import { ParallelJoinNode } from './ParallelJoinNode';
import { ParallelSplitNode } from './ParallelSplitNode';
import { StartNode } from './StartNode';

export const processNodeTypes: NodeTypes = {
  start: StartNode,
  decision: DecisionNode,
  parallel_split: ParallelSplitNode,
  parallel_join: ParallelJoinNode,
  end: EndNode,
};

export { DecisionNode, EndNode, ParallelJoinNode, ParallelSplitNode, StartNode };
